import React from "react";
import { SocItemDetailsOfqual } from "../../domain/SocItemDetailsOfqual";
import { Select } from "@ofqual/portal-components/components/Select";
import { Grid } from "@material-ui/core";
import { Controller } from "react-hook-form";
import { fieldLabels } from "./fieldLabels";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import {
  closingStatusRationaleService,
  closingStatusService,
  followupLeadService,
  ragRatingService,
} from "../../services";
import { SectionProps } from "./SectionProps";

export const FurtherQuestions: React.FC<SectionProps<SocItemDetailsOfqual>> = (
  sectionProps
) => {
  const { control, disabled } = sectionProps;

  const [
    followUpLeadLookups,
    closingStatusLookups,
    closingStatusRationaleLookups,
    ragRatingLookups,
  ] = useLookup(
    followupLeadService,
    closingStatusService,
    closingStatusRationaleService,
    ragRatingService
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="overallRagRating"
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.overallRagRating}
              readOnly={disabled}
              datatest="overallRagRating-field"
              required
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {ragRatingLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="overallFollowUpLead"
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.followUpLead}
              readOnly={disabled}
              datatest="overallFollowUpLead-field"
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {followUpLeadLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="overallClosingStatus"
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.closingStatus}
              readOnly={disabled}
              datatest="overallClosingStatus-field"
              required
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {closingStatusLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="overallClosingRationale"
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.closingStatusRationale}
              readOnly={disabled}
              datatest="overallClosingRationale-field"
              required
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {closingStatusRationaleLookups}
            </Select>
          )}
        />
      </Grid>
    </Grid>
  );
};
